import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { PWAInstallPrompt } from "./components/PWAInstallPrompt";
import { UpdateNotification } from "./components/UpdateNotification";
import { OfflineIndicator } from "./components/OfflineIndicator";
import { SkipLink } from "./components/accessibility/SkipLink";
import ErrorBoundary from "./components/ErrorBoundary";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import AddCatch from "./pages/AddCatch";
import BulkAddCatch from "./pages/BulkAddCatch";
import Profile from "./pages/Profile";
import Leaderboard from "./pages/Leaderboard";
import Statistics from "./pages/Statistics";
import Analytics from "./pages/Analytics";
import PublicCatch from "./pages/PublicCatch";
import NotFound from "./pages/NotFound";
import Install from "./pages/Install";
import Trips from "./pages/Trips";

const queryClient = new QueryClient();

const App = () => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <PWAInstallPrompt />
        <UpdateNotification />
        <OfflineIndicator />
        <BrowserRouter>
          <SkipLink />
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/add-catch" element={<AddCatch />} />
              <Route path="/edit-catch/:id" element={<AddCatch />} />
              <Route path="/bulk-add" element={<BulkAddCatch />} />
              <Route path="/trips" element={<Trips />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/statistics" element={<Statistics />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/install" element={<Install />} />
              <Route path="/catch/:id" element={<PublicCatch />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </ErrorBoundary>
);

export default App;
